
<app-background></app-background>

<!-- <div class="btn-language" ngbDropdown>
    <button type="button" class="btn btn-light" ngbDropdownToggle>
        <i class="bi bi-globe2"></i>
    </button>
    <div ngbDropdownMenu>
        <button ngbDropdownItem *ngFor="let lang of languages" [ngClass]="{'active': language == lang.code2}" (click)="selectLanguage(lang.code2)">{{ lang.value }}</button>
    </div>
</div> -->

<div class="main-container">
    <router-outlet></router-outlet>
</div>

<!-- <button type="button" class="btn btn-light btn-help">
    <i class="bi bi-chat-text"></i>
</button> -->